import React, { useState, useEffect, useContext } from 'react';
import Controls from "../../components/Controls";
import {useNavigate} from "react-router-dom";
import Header from "../../components/Header";
import StarBackground from "../../components/StarBackground";
import ExeCore from "../../components/ExeCore";
import Character from "../../components/Character";
import Planet from "../../components/Planet";
import '../../styles/Intro.css';
import config from './sentencesConfig';
import { AppContext } from '../../contexts/AppContext';

export default function SentencesTutorial() {
    const navigate = useNavigate();
    const { enableText } = useContext(AppContext);
    const overlayImage = `/assets/images/sentencesImages/tutorial.png`;
    const [isRecording, setIsRecording] = useState(false);

    const startRecording = () => {
        setIsRecording(true);
    };

    const stopRecording = () => {
        setIsRecording(false);
    };

    const [step, setStep] = useState(1);
    const [message, setMessage] = useState('');

    // Cambia messaggio in base allo step
    useEffect(() => {
        if (step === 1) {
            setMessage("Facciamo un esempio per scaldarci! Quando INIZIA il gioco, la persona che è con te cliccherà il tasto giallo play e ascolterai una frase.");
        } else if (step === 2) {
            setMessage("Ora si illuminerà il microfono di rosso e potrai parlare. Ripeti dopo di me: “Questo è un topo”");

            const timer = setTimeout(() => setStep(3), 10000);
            return () => clearTimeout(timer);
        } else if (step === 3) {
            setMessage("Premi il tasto verde per confermare.");
        } else if (step === 4) {
            setMessage("Perfetto, ora prova tu!");
            const timer = setTimeout(() => {
                navigate('/exercise/sentences/test');
            }, 1000);
            return () => clearTimeout(timer);
        } else {
            setMessage('');
            setMessage('');
        }
    }, [step]);

    const handlePlay = () => {

        // Trova l'audio in riproduzione (usato da Controls)
        const audio = document.querySelector('audio');
        if (!audio) {
            console.warn('Audio element not found');
            // In caso non ci sia audio, fai comunque proseguire dopo 2 secondi
            setTimeout(() => setStep(2), 2000);
            return;
        }

        // Quando l’audio termina, passa allo step successivo
        audio.addEventListener('ended', () => {
            setStep(2);
        }, { once: true });
    };

    const handleValidate = () => {
        setStep(4);
        if (onValidate) onValidate();
    };

    return (
        <div className="sentences-wrapper">
            <Header color={config.headerColor} />
            <StarBackground imagePath={config.planetBackground} />

            {/* Pianeta e overlay */}
            <ExeCore image={config.marsImage} size={config.marsSize} />
            <ExeCore image={overlayImage} size={config.marsSize} className="overlay-core" />

            {/* Controlli */}
            <Controls
                colors={config.controlColors}
                onRepeat={() => console.log('Repeat')}
                onStartRecording={startRecording}
                onStopRecording={stopRecording}
                onValidate={handleValidate}
                onPlay={handlePlay} // Aggiungi questa prop a Controls se non c’è
                context={'1'} //Sostituire con tutorial
                recording={isRecording}
                recordingMode="post-playback"
                disableUpload={true}
            />

            <Character name="Mars" position='left' isActive={true} />
            {enableText && <div className="bubble">{message}</div>}

            <Character
                name={config.character}
                position='right'
                isActive={false}
            />

            <Planet image={config.planetImage} />
        </div>
    );
}

